import React from 'react'
import { useNavigate } from 'react-router-dom';
import ButtonComponent from '../../components/ButtonComponent';

const ContactComplainPolicy = () => {
    const navigate = useNavigate();
    const handleBackToPolicyPage = () => {
        navigate('/documents');
    }
    return (
        <>
            <div className="container mt-5 privacy-policy"><ButtonComponent title='Back to Policy Page' backgroundColor=' #590B21' onClick={handleBackToPolicyPage} /></div>
            <div className="container mt-2 mb-5 py-4">
                <h3 className='fw-bold'>Contact and Complaint Policy</h3>
                <h6 className='fw-bold'>Curry King (Private) Limited</h6>
                <p> Version 1.2 | Last Updated: 6th May 2025</p>
                <p>
                    At Curry King (Private) Limited, we are committed to providing a high standard of customer service and ensuring that every customer interaction is handled professionally, courteously, and promptly. This policy outlines how customers may contact us for general inquiries or lodge complaints, and how we handle those complaints.
                </p>
                <hr />
                <h5 className='fw-bold'>1. Purpose</h5>
                <p>
                    This policy is intended to:
                </p>
                <ul>
                    <li>
                        Ensure customers know how to contact us or raise a complaint.
                    </li>
                    <li>
                        Provide a clear process for resolving complaints in a timely and respectful manner.
                    </li>
                    <li>
                        Enhance accountability and continuous improvement in our service delivery.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>2. Scope</h5>
                <p>
                    This policy applies to all Curry King customers using our services through:
                </p>
                <ul>
                    <li>
                        Mobile applications (iOS and Android)
                    </li>
                    <li>
                        Website <a href='https://www.curryking.lk'>(www.curryking.lk)</a>
                    </li>
                    <li>
                        Food cart pickup locations
                    </li>
                    <li>
                        Telephone, email, or other official communication channels
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>3. Contact Channels</h5>
                <p>Customers may reach us through any of the following official methods:</p>
                <h6 className='fw-bold'>Customer Service Hotline</h6>
                Phone: <strong>+94 11 444 1300</strong>
                <br />
                <p>Available: Monday to Saturday, 9:00 AM to 6:00 PM</p>
                <h6 className='fw-bold'>Customer Service Hotline</h6>
                <p>Email: <strong>support@curryking.lk</strong></p>

                <h6 className='fw-bold'>WhatsApp Support</h6>
                <p>
                    Available through the order confirmation link sent upon placing an order.
                </p>
                <h6 className='fw-bold'>Postal Address</h6>
                Curry King (Private) Limited
                <br />
                55/72, Vauxhall Lane, Colombo 2, Sri Lanka
                <br />
                <br />
                <p>We aim to acknowledge all customer communications within 24 hours during business days.</p>
                <hr />
                <h5 className='fw-bold'>4. How to Lodge a Complaint</h5>
                <p>To lodge a complaint, customers are requested to provide:</p>
                <ul>
                    <li>
                        Full name and contact details
                    </li>
                    <li>
                        Order reference or cart location (if applicable)
                    </li>
                    <li>
                        A clear description of the issue
                    </li>
                    <li>
                        Supporting evidence (e.g., photographs, screenshots, or receipt)
                    </li>
                    <li>
                        Preferred resolution (e.g., clarification, replacement, or refund)
                    </li>
                </ul>
                <p>
                    Complaints must be submitted through one of the official contact methods listed above. Anonymous complaints or those made through unofficial channels may not be investigated.
                </p>
                <hr />
                <h5 className='fw-bold'>5. Response and Resolution</h5>
                <p>All complaints will be:</p>
                <ul>
                    <li>
                        Acknowledged within <strong>1 business day</strong>
                    </li>
                    <li>
                        Investigated thoroughly and impartially
                    </li>
                    <li>
                        Responded to with a resolution or update within <strong>3 to 5 business days</strong>
                    </li>
                </ul>
                <p>
                    If additional time is required for investigation, the customer will be informed accordingly.
                    Where a complaint is found to be valid, we may offer one of the following remedies:
                </p>
                <ul>
                    <li>
                        Clarification or apology
                    </li>
                    <li>
                        Replacement of the affected product
                    </li>
                    <li>
                        Refund, in line with our Refund & Cancellation Policy
                    </li>
                    <li>
                        Assurance of corrective action
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>6. Escalation Procedure</h5>
                <p>If a customer is dissatisfied with the initial handling or resolution of a complaint, they may escalate the matter by submitting a written request to our <strong>Customer Experience Lead</strong> at the same contact address, marked “Complaint Escalation – Confidential.”</p>
                <p>Escalated cases will be reviewed by senior management and a final written response will be issued within <strong>7 business days.</strong></p>
                <hr />
                <h5 className='fw-bold'>7. Confidentiality</h5>
                <p>All customer complaints will be handled with strict confidentiality. Personal information will be used solely for the purpose of addressing and resolving the complaint, in accordance with our Privacy Policy.</p>
                <hr />
                <h5 className='fw-bold'>8. Policy Review</h5>
                <p>This policy is reviewed periodically to ensure effectiveness and compliance with customer service standards and regulatory requirements.</p>
                <hr />
                <p>For any feedback, concern, or complaint, we encourage you to reach out. Your satisfaction is important to us, and we are committed to continuous improvement.</p>
                <strong>Curry King (Private) Limited</strong>
                <br />
                55/72, Vauxhall Lane, Colombo 2, Sri Lanka
                <br />
                Email: <strong>support@curryking.lk</strong>
                <p>Phone: <strong>+94 11 444 1300</strong></p>
                <hr />
            </div>
        </>
    )
}

export default ContactComplainPolicy;